import SearchIcon from "shared/components/icons/SearchIcon";

/* eslint-disable @typescript-eslint/no-explicit-any */
type Props = {
  name: string;
  testid?: string;
  currentValue: any;
  onChange: (name: string, value: string | null) => void;
  className?: string;
  iconClassName?: string;
  wrapperClassName?: string;
};

export const TextInput = ({
  name,
  onChange,
  testid,
  currentValue,
  className,
  iconClassName,
  wrapperClassName,
  ...props
}: Props) => {
  return (
    <div className={`relative ${wrapperClassName}`}>
      <input
        type="text"
        className={className ?? "w-full !pl-4.5 !pr-4"}
        placeholder="Search"
        name={name}
        data-testid={testid}
        value={currentValue ?? ""}
        onChange={(e) => onChange(name, e.target.value)}
        {...props}
      />
      <div className="absolute inset-y-0 left-0 pl-1 flex items-center pointer-events-none text-slate-400">
        <SearchIcon className={`text-neutral-mid-500 ${iconClassName}`} />
      </div>
    </div>
  );
};
